import { createListenerMiddleware } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';
import { combineReducers } from 'redux';
import actionsDispatched from './ActionsDispatched';
import config from './Config';
import experimentation from './Experimentation';
import marketingContacts from './MarketingContacts';
import numContactsInCrm from './NumContactsInCrm';
import planBuilder from './PlanBuilder';
import productInventory from './ProductInventory';
import abstractedProducts from './Products';
import promotions from './Promotions';
import publicFeatureFlags from './PublicFeatureFlags';
import purchaseMotionsByLocation from './PurchaseMotionsByLocation';
import queryParamTerm from './QueryParamTerm';
import requests from './Requests';
import { upgradePageViewReducer as upgradePageView } from './UpgradePageView';
import auth from './auth';
import requiredOnboarding from './requiredOnboarding';
export const rootReducer = combineReducers({
  auth,
  requiredOnboarding,
  requests,
  actionsDispatched,
  abstractedProducts,
  promotions,
  config,
  numContactsInCrm,
  marketingContacts,
  purchaseMotionsByLocation,
  queryParamTerm,
  publicFeatureFlags,
  productInventory,
  experimentation,
  upgradePageView,
  planBuilder
});

// This type represents the state of your root reducer,
// and can be useful when creating selectors
export const createAppListenerMiddleware = createListenerMiddleware;

// Should be used in place of useDispatch throughout the application
export function useAppDispatch() {
  return useDispatch();
}
export const useAppSelector = useSelector;